import { render } from "./BotaoAcoes.vue?vue&type=template&id=37fb5876&ts=true"
import script from "./BotaoAcoes.vue?vue&type=script&lang=ts"
export * from "./BotaoAcoes.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__